import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import html2canvas from "html2canvas";
import styles from "./selfiepage.module.css";
import meghna from "../meghna.png";
import lotus from "../lotus.png";

const CaptureAndDisplay = () => {
  const webcamRef = useRef(null);
  const pageRef = useRef(null);
  const [capturedImage, setCapturedImage] = useState(null);

  const handleCapture = async () => {
    if (webcamRef.current) {
      const cameraImage = webcamRef.current.getScreenshot();
      setCapturedImage(cameraImage);
    }
  };

  const handleDownload = async () => {
    if (pageRef.current) {
        document.getElementById("download").style.display="none";
      const canvas = await html2canvas(pageRef.current);
      const image = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = image;
      link.download = "selfie_with_didi.png";
      link.click();
    }
    document.getElementById("download").style.display="block";

  };

  return (
    <div className={styles.container} ref={pageRef}>
      {/* Header Section */}
      <div className={styles.upper}>
      <div className={styles.heading}>
        <img src={lotus} alt="lotus" className={styles.icon} />
      </div>
      <div className={styles.heading2}>
        देऊन दीदी ना साथ , करू विकासाची सुरवात
      </div>
      </div>
      {/* Camera and Captured Image Section */}
      <div className={styles.circle}>
        {capturedImage ? (
          <img
            src={capturedImage}
            alt="Captured"
            className={styles.capturedImage}
          />
        ) : (
          <Webcam
            ref={webcamRef}
            mirrored={true}

            audio={false}
            screenshotFormat="image/png"
            className={styles.webcam}
          />
        )}
      </div>

      {/* Capture Button */}
      {/* {!capturedImage && (
        <button className={styles.captureButton} onClick={handleCapture}>
          Capture
        </button>
      )} */}

      {/* Footer Section */}
      <div className={styles.footer}>
        <img
          src={meghna} // Replace with the actual image path
          alt="Person"
          className={styles.footerImage}
        />
      </div>

      {/* Download Button */}
      <button className={styles.downloadButton} id="download" onClick={handleDownload}>
        Download 
      </button>
    </div>
  );
};

export default CaptureAndDisplay;
